var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsIconsBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.75 20c0 .729-.29 1.429-.805 1.945A2.755 2.755 0 0 1 18 22.75H6c-.729 0-1.429-.29-1.945-.805A2.755 2.755 0 0 1 3.25 20V4c0-.729.29-1.429.805-1.945A2.755 2.755 0 0 1 6 1.25h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237zM8 18.75h4.5a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5zm0-3.5h8a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5zM14.5 3v3.5a1 1 0 0 0 1 1H19zM8 11.75h8a.75.75 0 0 0 0-1.5H8a.75.75 0 0 0 0 1.5z",
    fill: "#5555FF",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIconsBlue);
export default __webpack_public_path__ + "static/media/DocumentsIconsBlue.652be451c0407603dfb4824a3f717d20.svg";
export { ForwardRef as ReactComponent };